"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var globalContext_1 = require("./globalContext");
function createActionId() {
    return (globalContext_1.getGlobalContext().nextActionId++).toString();
}
exports.default = createActionId;
